import type { PageMeta } from '@coorum-research/shared-common/types/page-meta.type'
import { ulid } from 'ulidx'
import { setPageMeta } from '../utils/page-meta-storage.util'

export class PageAnalyticsManager {
  #pageMeta: PageMeta | undefined

  constructor() {
    // initial page view data
    this.capturePageView()

    // console.log('PageAnalyticsManager constructor')
    // console.log('this.#pageMeta: ', this.#pageMeta)

    // TODO: add event listener for page url change
  }

  /**
   * ページメタデータを取得
   */
  public currentPageMeta(): PageMeta {
    if (!this.#pageMeta) {
      throw new Error('Page meta data is not initialized')
    }

    return this.#pageMeta
  }

  /**
   * 現在のページビューデータを収集して保存
   * ページ遷移時に呼び出す。
   * TODO: SPAでの遷移(History(API) Routing or Hash Routing)にも対応するためには、追加の実装が必要
   */
  public capturePageView(): void {
    this.#pageMeta = this.generatePageMeta()
    setPageMeta(this.#pageMeta)
  }

  /**
   * ページメタデータの生成
   */
  private generatePageMeta(): PageMeta {
    return {
      title: document.title,
      referrer: document.referrer,
      url: window.location.href,
      screenWidth: window.screen.width,
      screenHeight: window.screen.height,
      innerWidth: window.innerWidth,
      innerHeight: window.innerHeight,
      outerWidth: window.outerWidth,
      outerHeight: window.outerHeight,
      insertId: this.generateId(),
      localDate: Date.now(),
    }
  }

  /**
   * ユニークIDの生成
   */
  private generateId(): string {
    return ulid()
  }
}
